/**
 *Created by jmmartinez on 07/02/20
 *
 * v.1.1 15/04/2020 Añadida propiedad usuario.
 *                  Paso de propiedad usuario a saveConfiguracion
 * v.1.2 12/05/2020 Añadida la copia del campo visibilidad  al crear la nueva columnaEstado en evento changeColumna
 * v.2.0 30/09/2020 Cambiado a framework2
 * v.2.1 11/02/2021 Modificaciones para soportar la nueva propiedad Alto de DefinicionIf
 * v.2.2 06/08/2021 Eliminadas propiedades columnasActuales y alto, pq lo obtenemos del REDUX
 *                  Eliminada columnaActuales de getDerivedStateFromProps
 *                  Añadida propiedad ifid
 *                  Añadida dependencia con el REDUX definicionesif
 *                  Eliminado Columnas y Alto del constructor
 * v.2.3 09/08/2021 Nueva versión completa.
 *                  Añadida gestión de tamaño de columnas
 * v.2.4 10/08/2021 Añadida gestión de orden.
 **/

import React, {createRef} from 'react'
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {Checkbox, Icon, Button, InputGroup, FormGroup} from "@blueprintjs/core";
import {
    generarColumnasEstado,
    ordenarColumnasEstado,
    generarColumnasDesdeColumnasEstado,
    saveConfiguracion,
    crearDefinicion,
} from "../utils/ConfiguracionInterfaceUtils"
import {COLUMNVISIBLE_VARIABLE} from "./TiposCeldas";
import {primerElementoConValorPropiedad} from "../utils/ArrayUtils";
import {definicionifChanged} from "../../../dental/redux/definicionesif/actions";
import "../../resources/css/configuraciongrid.css"
import "../../resources/css/formulariobotonera.css"



class ConfiguracionGrid extends React.Component {

    constructor(props) {
        super(props)
        console.log("CONFIGURACIONGRID constructor");

        let definicionif= props.definicionesif.definicionesif[props.ifid];
        if (!definicionif)
            definicionif= crearDefinicion(props.ifid, 350, props.columnas);
        console.log("definicionif: ", definicionif);
        console.log("Columnas:", props.columnas);

        this.state = {
            columnas: props.columnas,
            columnasEstado: ordenarColumnasEstado(generarColumnasEstado(props.columnas, definicionif.columns, props.anchosColumnas)),
            alto: definicionif.alto,
            definicionif: definicionif,
            algunAnchoModificado: false,
            columnaEstadoDestacada: null,
        }

        this.refsUp= {};
        this.state.columnasEstado.forEach((columnaEstado) => {
            this.refsUp[columnaEstado.campo]= React.createRef();
        });
        //console.log("ColumnasEstado:", this.state.columnasEstado);
        this.refButton= React.createRef();
    }


    componentDidUpdate() {
        const {columnaEstadoDestacada} = this.state;
        console.log("UPDATE");
        console.log("columnaEstadoDestacada: ", columnaEstadoDestacada);
        /*
        console.log("refs: ", this.refsUp);
        if (columnaEstadoDestacada){
            let ref= this.refsUp[columnaEstadoDestacada.campo];
            console.log("ref: ", ref);
            ref.current.focus();
        }

         */
    }




    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.columnas !== prevState.columnas) {
            newState.columnas = nextProps.columnas;
            //newState.columnasEstado= ordenarColumnasEstado(generarColumnasEstado(nextProps.columnas, definicionif.columns, nextProps.anchosColumnas));
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }



    aceptar = () => {
        const {columnasEstado, alto, definicionif, algunAnchoModificado} = this.state;
        const {ifid, usuario, columnas, onAceptar} = this.props;

        //console.log("ACEPTAR");
        //console.log(columnasEstado);

        //1. Guardamos en la BDD
        saveConfiguracion(ifid, usuario, columnasEstado, alto, definicionif);

        //2. Guardamos en Redux
        let newDefinicionif={...definicionif};
        newDefinicionif.alto= alto;
        newDefinicionif.columns= columnasEstado;
        this.props.dispatch(definicionifChanged(ifid, newDefinicionif));

        //3. Salimos devolviendo la nueva configuración para aplicarla en el Grid
        onAceptar && onAceptar(generarColumnasDesdeColumnasEstado(columnasEstado, columnas), alto, algunAnchoModificado);
    }



    cancelar = () => {
        const {onCancelar} = this.props;
        onCancelar && onCancelar();
    }


    onColumnaUpDown= (index, columnaEstado, variacion) => {
        const {columnasEstado} = this.state;

        //intercambiamos los ordenes de la actual y la anterior
        let oldOrden= columnasEstado[index].orden;
        columnasEstado[index].orden = columnasEstado[index + variacion].orden
        columnasEstado[index + variacion].orden = oldOrden;
        let newColumnasEstado= ordenarColumnasEstado([...columnasEstado]);
        this.setState({columnasEstado: newColumnasEstado, columnaEstadoDestacada : columnaEstado});
    }



    changeColumna= (columnaEstado, visible, ancho) => {
        const {columnasEstado} = this.state;
        let nuevasColumnasEstado= [];
        let algunAnchoModificado= false;
        columnasEstado.forEach( (columnaEstadoActual) => {
            let newColumnaEstado= {...columnaEstadoActual};
            if (columnaEstadoActual.campo === columnaEstado.campo) {
                if (visible != null)
                    newColumnaEstado.visible= Boolean(visible);
                if (ancho) {
                    newColumnaEstado.ancho = Number(ancho);
                    algunAnchoModificado= true;
                }
                //console.log("newColumnaEstado: ", newColumnaEstado);
            }
            nuevasColumnasEstado.push(newColumnaEstado);
        });

        this.setState({columnasEstado: nuevasColumnasEstado, algunAnchoModificado: algunAnchoModificado});
    }


    changeAlto= (cadNewAlto) => {
        if (!isNaN(cadNewAlto)){
            this.setState({alto: Number(cadNewAlto)});
        }
    }


    renderColumna= (columnaEstado, index) => {
        const{columnasEstado, columnaEstadoDestacada} = this.state;
        let columnaEnabled= columnaEstado.visibilidad &&  columnaEstado.visibilidad === COLUMNVISIBLE_VARIABLE;
        let className= columnaEstadoDestacada && columnaEstado.campo === columnaEstadoDestacada.campo ? "configuraciongrid_columnadestacada" : "configuraciongrid_columna";
        let mostrarUp= index >0;
        let mostrarDown=  index < columnasEstado.length -1;
        let classNameDown= mostrarUp ? "configuraciongrid_boton" : "configuraciongrid_botondesplazado";
        return (
            <div className={className}>
                <Checkbox
                    key={index}
                    className="configuraciongrid_check"
                    checked={ columnaEstado.visible}
                    disabled={ !columnaEnabled}
                    onChange={ (event) =>  this.changeColumna(columnaEstado, event.target.checked, null)}>
                    {columnaEstado.titulo}
                </Checkbox>
                <InputGroup
                    className="configuraciongrid_ancho"
                    leftIcon="drag-handle-vertical"
                    placeholder="Ancho"
                    disabled={ !columnaEnabled}
                    value={columnaEstado.ancho}
                    onChange={ (event) =>  this.changeColumna(columnaEstado, null, event.target.value)}/>
                {mostrarUp &&
                <Icon className="configuraciongrid_boton" icon="circle-arrow-up"
                      onClick={() => this.onColumnaUpDown(index, columnaEstado, -1)}/>
                }
                {mostrarDown &&
                <Icon className={classNameDown} icon="circle-arrow-down" onClick={() => this.onColumnaUpDown(index, columnaEstado, 1)}/>
                }
            </div>
        );

    }

    render() {
        const {columnasEstado, alto} = this.state;

        //console.log("RENDER ---- ");
        //console.log(columnasEstado);

        return (
            <div style={{margin: 5}}>
                {
                    <div>
                    {
                        columnasEstado.map ( (columnaEstado, index) => {
                            //console.log("columnaEstado: ", columnaEstado.titulo, "  orden: ", columnaEstado.orden);
                            return this.renderColumna(columnaEstado, index);
                        })
                    }
                    </div>
                }
                <FormGroup label= "Alto" labelFor="alto" inline={true} className="configuraciongrid_alto">
                    <InputGroup
                        id="alto"
                        leftIcon="drag-handle-vertical"
                        placeholder="Alto"
                        value={alto}
                        onChange={(event) => this.changeAlto(event.target.value)}
                    />
                </FormGroup>
                <div className="botonera" ref={this.refButton}>
                    <Button icon="saved" onClick={this.aceptar}>Aceptar</Button>
                    <Button style={{marginLeft: 10}} icon="delete" onClick={this.cancelar}>Cancelar</Button>
                </div>
            </div>
        );
    }
}

/*
 return <ConfiguracionColumn index={index} columnaEstado={columnaEstado}
                                                        onColumnaModificada={this.changeColumna}
                                                        mostrarUp={index > 0}
                                                        onUp={this.onColumnaUp}
                                />
                            })
 */


ConfiguracionGrid.propTypes = {
    ifid: PropTypes.string.isRequired,
    usuario: PropTypes.object.isRequired,
    columnas: PropTypes.array.isRequired,
    anchosColumnas: PropTypes.array.isRequired,
    onAceptar: PropTypes.func,
    onCancelar: PropTypes.func,

}


const mapStateToProps = function(state) {
    return {
        definicionesif: state.definicionesif
    }
}

export default connect(mapStateToProps)(ConfiguracionGrid);
